(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["seguimiento-pedido"] && !Shopify.designMode) return;
  try {
    Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  };

  document.addEventListener('DOMContentLoaded', function() {
    var expandableItems = document.querySelectorAll(".gfw-expandable-box h3");
    for (var index = 0; index < expandableItems.length; index++) {
      var element = expandableItems[index];
      element.addEventListener("click", function(e) {
        e.preventDefault();
        var theExpandableItem = this.parentNode;
        theExpandableItem.classList.toggle("active");
      });
    }

    var queryString = window.location.search;
    var urlCustomParams = new URLSearchParams(queryString);
    var id = urlCustomParams.get("id");
    if (id != null) id = id.replace("#", "");

    var emailParam = urlCustomParams.get("email");
    if (emailParam != null) {
      var emailInput = document.getElementById("FormNuevaBusquedaEmail");
      if (emailInput) emailInput.value = emailParam;
    }

    var codeShippy = "";
    var StatusCode = {};
    var StatusText = {};

    StatusCode[0] = "Registrado";
    StatusCode[1] = "Preparado";
    StatusCode[2] = "En camino";
    StatusCode[3] = "En reparto";
    StatusCode[4] = "Con retraso";
    StatusCode[5] = "Error entrega";
    StatusCode[6] = "Entregado";

    StatusText[0] = "Pedido realizado correctamente";
    StatusText[1] = "Pedido preparado para su transporte";
    StatusText[2] = "Tu pedido se encuentra en camino";
    StatusText[3] = "Pedido en proceso de entrega";
    StatusText[4] = "";
    StatusText[5] = "";
    StatusText[6] = "Pedido entregado al destinatario o autorizado";

    var urlOrder = "https://getkomvidaorder-6dq5z3xksa-nw.a.run.app?order_name=" + id + "&email=" + emailParam;

    fetch(urlOrder)
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data.financial_status == "paid") {
          if (data.fulfillments && data.fulfillments[0].tracking_company != "PAACK") {
            codeShippy = data.fulfillments[0].tracking_number;
            var carrier = data.fulfillments[0].tracking_company;
            var spanCarrier = document.getElementById("carrier");
            if (spanCarrier) spanCarrier.innerText = carrier;
          } else {
            if ((data.fulfillments && data.fulfillments[0].tracking_company == "PAACK") || (data.tags && data.tags.includes("PAACK"))) {
              hideOrder();
              showPaack();
            } else {
              var txtSeguimiento = document.getElementById("txtSeguimiento");
              if (txtSeguimiento) txtSeguimiento.innerHTML = "<strong>Pronto podrás realizar el seguimiento desde el sitio web de Seur. Por favor, inténtalo de nuevo dentro de unas horas.</strong>";
              var lnkCode = document.getElementById("lnkCode");
              if (lnkCode) {
                lnkCode.style.display = "none";
                lnkCode.removeAttribute("href");
              }
            }
          }

          var code = document.getElementById("code");
          var code2 = document.getElementById("code2");
          var code3 = document.getElementById("code3");
          var numcode = data.name.replace("#", "");
          if (code) code.innerText = "#" + numcode;
          if (code2) code2.innerText = "#" + numcode;
          if (code3) code3.innerText = "#" + numcode;

          var spanCustomer = document.getElementById("customer");
          if (spanCustomer) spanCustomer.innerText = data.shipping_address.first_name + " " + data.shipping_address.last_name;
          var spanEmail = document.getElementById("email");
          if (spanEmail) spanEmail.innerText = data.email;
          var spanPhone = document.getElementById("phone");
          if (spanPhone) spanPhone.innerText = data.shipping_address.phone;
          var spanAddress1 = document.getElementById("address1");
          if (spanAddress1) spanAddress1.innerText = data.shipping_address.address1;
          var spanCity = document.getElementById("city");
          if (spanCity) spanCity.innerText = data.shipping_address.city;
          var spanZip = document.getElementById("zip");
          if (spanZip) spanZip.innerText = data.shipping_address.zip;
          var spanCountry = document.getElementById("country");
          if (spanCountry) spanCountry.innerText = data.shipping_address.country;

          var fulfillment_date = null;
          if ((data.fulfillment_status == "fulfilled" || data.fulfillment_status == "partial") && data.fulfillments)
            fulfillment_date = data.fulfillments[0].created_at;

          var spanDeliveryDate = document.getElementById("estimated_delivery_date");
          if (spanDeliveryDate) spanDeliveryDate.innerText = calculateDeliveryDate(data.processed_at, fulfillment_date);
          var bannerFechaEntrega = document.getElementById("bannerFechaEntrega");
          if (bannerFechaEntrega) bannerFechaEntrega.style.display = "block";

          var resumen = document.getElementById("resumen");
          var products = data.line_items;
          var type = data.type;
          switch (type) {
            case "Single":
              type = "Compra única";
              break;
            default:
              type = "Suscripción";
          }
          products.forEach(function(product) {
            var newNode = document.createElement("div");
            newNode.classList.add("row");
            newNode.innerHTML =
              '<div class="col-4">' +
                '<img src="' + product.image + '">' +
              '</div>' +
              '<div class="col-8">' +
                '<table>' +
                  '<tr>' +
                    '<td>' + product.name + '</td>' +
                    '<td>&nbsp;</td>' +
                  '</tr>' +
                  '<tr>' +
                    '<td>Cantidad:</td>' +
                    '<td>X' + product.quantity + '</td>' +
                  '</tr>' +
                  '<tr>' +
                    '<td>Tipo de pedido:</td>' +
                    '<td><span>' + type + '</span></td>' +
                  '</tr>' +
                  '<tr class="gfw-separator-row">' +
                    '<td>&nbsp;</td>' +
                    '<td>&nbsp;</td>' +
                  '</tr>' +
                '</table>' +
              '</div>';
            if (resumen && resumen.parentNode) resumen.parentNode.insertBefore(newNode, resumen.previousSibling);
          });

          var spanEnvio = document.getElementById("envio");
          if (spanEnvio) spanEnvio.innerText = data.total_shipping_price.amount.replace(".", ",");
          var spanIva = document.getElementById("iva");
          if (spanIva) spanIva.innerText = data.total_tax.replace(".", ",");
          var spanTotal = document.getElementById("total");
          if (spanTotal) spanTotal.innerText = data.total_price.replace(".", ",");

          var stepPaid = document.getElementById("stepPaid");
          if (data.financial_status == "paid") {
            var dateFormat = new Date(data.processed_at);
            var options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
            var stepDate = document.getElementById("stepDatePaid");
            if (stepDate) stepDate.innerText = dateFormat.toLocaleDateString("es-ES", options) + " " + dateFormat.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
            if (stepPaid) stepPaid.style.display = "block";

            var stepCarFullfilled = document.getElementById("stepCarFullfilled");
            if (stepCarFullfilled) stepCarFullfilled.classList.add("on");
            var carStep = document.querySelector(".gfw-step-car");
            if (carStep) {
              carStep.style.display = "block";
              carStep.style.left = "0%";
            }

            var spanStatus = document.getElementById("status");
            if (spanStatus) spanStatus.innerText = StatusCode[0];
            var spanStatusText = document.getElementById("statusText");
            if (spanStatusText) spanStatusText.innerText = StatusText[0];
          }

          var stepFullfilled = document.getElementById("stepFullfilled");
          if (data.fulfillment_status == "fulfilled") {
            var dateFormat2 = new Date(data.closed_at);
            var options2 = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
            var stepDate2 = document.getElementById("stepDateFullfilled");
            if (stepDate2) stepDate2.innerText = dateFormat2.toLocaleDateString("es-ES", options2) + " " + dateFormat2.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
            if (stepFullfilled) stepFullfilled.style.display = "block";

            var stepCarFullfilled2 = document.getElementById("stepCarFullfilled");
            if (stepCarFullfilled2) stepCarFullfilled2.classList.add("on");
            var carStep2 = document.querySelector(".gfw-step-car");
            if (carStep2) {
              carStep2.style.display = "block";
              carStep2.style.left = "0%";
            }

            var spanStatus2 = document.getElementById("status");
            if (spanStatus2) spanStatus2.innerText = StatusCode[1];
            var spanStatusText2 = document.getElementById("statusText");
            if (spanStatusText2) spanStatusText2.innerText = StatusText[1];
          }

          if (codeShippy != "") {
            var urlShippyPro = "https://gettrackshippypro-6dq5z3xksa-nw.a.run.app?code=" + codeShippy;
            fetch(urlShippyPro)
              .then(function(response) { return response.json(); })
              .then(function(shipData) {
                if (shipData.code) {
                  var lnkCode2 = document.getElementById("lnkCode");
                  if (lnkCode2) lnkCode2.href = shipData.external_link;
                  var spanStatus3 = document.getElementById("status");
                  if (spanStatus3) spanStatus3.innerText = StatusCode[shipData.status_code];
                  var spanStatusText3 = document.getElementById("statusText");
                  if (spanStatusText3) spanStatusText3.innerText = StatusText[shipData.status_code];

                  if (shipData.status_code == 6) {
                    var finalStep = document.querySelector(".gfw-final-step");
                    if (finalStep) finalStep.style.display = "block";
                    var carStep3 = document.querySelector(".gfw-step-car");
                    if (carStep3) carStep3.style.display = "none";
                  } else {
                    var carStep4 = document.querySelector(".gfw-step-car");
                    if (carStep4) {
                      switch (shipData.status_code) {
                        case 1: carStep4.style.left = "25%"; break;
                        case 2: carStep4.style.left = "45%"; break;
                        case 3:
                        case 4:
                        case 5: carStep4.style.left = "70%"; break;
                      }
                      carStep4.style.display = "block";
                    }
                  }

                  var details = shipData.details;
                  details.forEach(function(detail) {
                    if (detail.StatusCode != 1) {
                      var statusCode = detail.StatusCode;
                      var message = "";
                      var extraCss = "";
                      var extraCssStatus = "";
                      switch (detail.StatusCode) {
                        case 4:
                        case 5:
                          message = detail.message;
                          extraCss = "problem";
                          break;
                        default:
                          message = StatusText[statusCode];
                          extraCssStatus = " success";
                      }
                      var stepFullfilledEl = document.getElementById("stepFullfilled");
                      var newNode = document.createElement("div");
                      newNode.classList.add("gfw-step-expandable-box");
                      if (extraCss != "") newNode.classList.add(extraCss);

                      if (stepFullfilledEl) {
                        var dateFormat3 = new Date(detail.date * 1000);
                        var options3 = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
                        var stepDate3 = dateFormat3.toLocaleDateString("es-ES", options3) + " " + dateFormat3.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
                        var stepEl = document.getElementById("stepCar" + statusCode);
                        if (statusCode != 4 && statusCode != 5 && stepEl) stepEl.classList.add("on");

                        newNode.innerHTML =
                          '<div class="gfw-step-status' + extraCssStatus + '">' +
                            '<strong>' + StatusCode[statusCode] + '</strong><br>' +
                            '<span>' + stepDate3 + '</span>' +
                          '</div>' +
                          '<div class="gfw-step-details">' +
                            '<span>' + message + '</span>' +
                          '</div>';

                        stepFullfilledEl.parentNode.insertBefore(newNode, stepFullfilledEl.nextSibling);
                      }
                    } else {
                      var stepCar1 = document.getElementById("stepCar1");
                      if (stepCar1) stepCar1.classList.add("on");
                    }
                  });
                } else {
                  var lnkCode3 = document.getElementById("lnkCode");
                  if (lnkCode3) {
                    lnkCode3.innerText = "Enlace aún no disponible, inténtalo de nuevo en unas horas";
                    lnkCode3.removeAttribute("href");
                  }
                  errorTrack("shipment not found");
                }
              });
          }
        } else {
          errorTrack("order not found");
          hideOrder();
        }
      });

    var buscarPedido = document.getElementById("BuscarPedido");
    if (buscarPedido) {
      buscarPedido.addEventListener("click", function(e) {
        e.preventDefault();
        var theEmail = document.getElementById("FormNuevaBusquedaEmail").value;
        var theOrder = document.getElementById("FormNuevaBusquedaOrder").value.replace("#", "");
        if (theEmail != "" && theOrder != "") {
          newOrderSearch(theEmail, theOrder);
        }
      });
      buscarPedido.addEventListener("keydown", function(e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          buscarPedido.click();
        }
      });
    }

    function newOrderSearch(email, order) {
      var thePath = "https://komvida.com/pages/seguimiento-pedidos?id=" + order + "&email=" + email;
      window.location.href = thePath;
    }

    function hideOrder() {
      var infoItems = document.querySelectorAll(".gfw-info-box");
      infoItems.forEach(function(infoItem) {
        infoItem.style.display = "none";
      });
      var lnkHead = document.getElementById("lnkHead");
      if (lnkHead) lnkHead.style.display = "none";
      var orderHead = document.getElementById("orderHead");
      if (orderHead) orderHead.style.display = "none";
      var orderInfo = document.getElementById("orderInfo");
      if (orderInfo) orderInfo.style.display = "none";
      var deliverInfo = document.getElementById("deliverInfo");
      if (deliverInfo) deliverInfo.style.display = "none";
    }

    function calculateDeliveryDate(first_status_date, fulfillment_date) {
      var dias = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
      var meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

      var first_date = new Date(first_status_date);
      var fecha_entrega = new Date(first_status_date);
      var fecha_entrega_inicial = new Date(first_status_date);
      var fecha_rango = false;
      var today_number = first_date.getDay();
      var now_time = "" + first_date.getHours() + first_date.getMinutes();

      if (fulfillment_date == null) {
        if (today_number < 5 && now_time < 1230) {
          fecha_entrega.setHours(fecha_entrega.getHours() + 24);
        }
        if (today_number < 5 && now_time > 1230 && now_time < 1400) {
          fecha_rango = true;
          fecha_entrega_inicial.setHours(fecha_entrega.getHours() + 24);
          fecha_entrega.setHours(fecha_entrega.getHours() + 48);
        }
        if (today_number < 5 && now_time > 1400) {
          fecha_entrega.setHours(fecha_entrega.getHours() + 48);
        }
        if (today_number == 5 && now_time < 1230) {
          fecha_entrega.setHours(fecha_entrega.getHours() + 24);
        }
        if (today_number == 5 && now_time > 1230 && now_time < 1400) {
          fecha_rango = true;
          fecha_entrega_inicial.setHours(fecha_entrega.getHours() + 24);
          var Nday = (fecha_entrega.getDay() == 0) ? 7 : fecha_entrega.getDay();
          var SumDay = 7 - Nday;
          fecha_entrega.setDate(fecha_entrega.getDate() + SumDay + 2);
        }
        if (today_number == 5 && now_time > 1400) {
          var Nday2 = (fecha_entrega.getDay() == 0) ? 7 : fecha_entrega.getDay();
          var SumDay2 = 7 - Nday2;
          fecha_entrega.setDate(fecha_entrega.getDate() + SumDay2 + 2);
        }
        if (today_number > 5) {
          var Nday3 = (fecha_entrega.getDay() == 0) ? 7 : fecha_entrega.getDay();
          var SumDay3 = 7 - Nday3;
          fecha_entrega.setDate(fecha_entrega.getDate() + SumDay3 + 2);
        }
      } else {
        fecha_entrega = new Date(fulfillment_date);
        fecha_entrega.setHours(fecha_entrega.getHours() + 24);
      }

      var today = new Date();
      var tomorrow = today.addDays(1);
      var fecha_estimada_entrega;

      if (!fecha_rango) {
        if (fecha_entrega.getDate() == today.getDate() && fecha_entrega.getMonth() == today.getMonth()) {
          fecha_estimada_entrega = "Hoy, " + fecha_entrega.getDate() + " de " + meses[fecha_entrega.getMonth()];
        } else {
          if (fecha_entrega.getDate() == tomorrow.getDate() && fecha_entrega.getMonth() == tomorrow.getMonth()) {
            fecha_estimada_entrega = "Mañana, " + fecha_entrega.getDate() + " de " + meses[fecha_entrega.getMonth()];
          } else {
            fecha_estimada_entrega = dias[fecha_entrega.getDay()] + ", " + fecha_entrega.getDate() + " de " + meses[fecha_entrega.getMonth()];
          }
        }
      } else {
        fecha_estimada_entrega = "Entre el " + dias[fecha_entrega_inicial.getDay()] + ", " + fecha_entrega_inicial.getDate() + " de " + meses[fecha_entrega_inicial.getMonth()] + " y el " + dias[fecha_entrega.getDay()] + ", " + fecha_entrega.getDate() + " de " + meses[fecha_entrega.getMonth()];
      }
      return fecha_estimada_entrega;
    }

    function showPaack() {
      var msgPaack = document.getElementById("msgPaack");
      if (msgPaack) msgPaack.style.display = "block";
      var searchItems = document.querySelectorAll(".gfw-buscar-pedido");
      searchItems.forEach(function(searchItem) {
        searchItem.style.display = "none";
      });
    }

    function errorTrack(message) {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          "event": "shipment-tracking-error",
          "error_message": message
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
